import { Injectable, inject } from '@angular/core';
import { AbstractCrudOperations, ServiceTransactionsEnum, RoleRequirements } from './abstract/abstract-crud-operations';
import { DataType, DataTypeCreate, DataTypeUpdate, Role } from './model';
import { AuthService } from './auth.service';

export enum DataTypeTransactionsEnum {
  GET_ALL = 'data-types-get-all',
  GET_BY_ID = 'data-types-get-by-id',
  CREATE = 'data-types-create',
  UPDATE = 'data-types-update',
  DELETE = 'data-types-delete',
}

@Injectable({
  providedIn: 'root',
})
export class DataTypeService extends AbstractCrudOperations<DataType, DataTypeCreate, DataTypeUpdate> {
  protected override transactions: Record<ServiceTransactionsEnum, string> = {
    [ServiceTransactionsEnum.GET_ALL]: DataTypeTransactionsEnum.GET_ALL,
    [ServiceTransactionsEnum.GET_BY_ID]: DataTypeTransactionsEnum.GET_BY_ID,
    [ServiceTransactionsEnum.CREATE]: DataTypeTransactionsEnum.CREATE,
    [ServiceTransactionsEnum.UPDATE]: DataTypeTransactionsEnum.UPDATE,
    [ServiceTransactionsEnum.DELETE]: DataTypeTransactionsEnum.DELETE,
  };

  override readonly resource = 'data-types';

  protected override roleRequirements: RoleRequirements = {
    create: [Role.Admin, Role.Manager],
    update: [Role.Admin, Role.Manager, Role.User],
    delete: [Role.Admin, Role.Manager],
  };

  protected override authService = inject(AuthService);
}
